exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-d727bb58] h1{font-size:48px;font-family:SFPro;line-height:1.1;font-weight:700;color:#000}[data-v-d727bb58] h2,h3[data-v-d727bb58],h4[data-v-d727bb58]{font-family:SFProBold}[data-v-d727bb58] h2{font-size:28px}[data-v-d727bb58] h3{font-size:20px}[data-v-d727bb58] h4{font-size:16px}.centered[data-v-d727bb58]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d727bb58","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/issuance-policies/IssuancePolicies.vue
// module id = s9kv
// module chunks = 0